import React from "react";
import { FormControlLabel, Radio, RadioGroup } from "@mui/material";

const RadioYearHandlingFragment = ({
  updateRulesAfterEdit,
  editable,
  params,
}) => {
  const handleYearRadio = (event) => {
    let newRow = structuredClone(params.row);
    newRow.RuleFacts.DisplayHistoryYear = event.target.value;
    updateRulesAfterEdit(newRow, params.row);
  };

  return (
    <RadioGroup
      value={params.row.RuleFacts.DisplayHistoryYear || "Rolling"}
      onChange={handleYearRadio}
      name={"year-radios_" + params.id}
      sx={{
        "& .MuiFormControlLabel-root": {
          margin: "0 !important",
          padding: "0 !important",
          minHeight: "20px !important",
        },
        "& .MuiFormControlLabel-label": {
          marginLeft: "5px",
          fontSize: "0.8rem",
          lineHeight: "1",
          padding: 0,
        },
        "& .MuiRadio-root": {
          padding: 0,
          margin: 0,
        },
        padding: 0,
        margin: 0,
      }}
    >
      <FormControlLabel
        value="Rolling"
        disabled={!editable}
        control={<Radio size="small" />}
        label="Rolling"
        labelPlacement="end"
      />
      <FormControlLabel
        value="Calendar"
        disabled={!editable}
        control={<Radio size="small" />}
        label="Calendar"
        labelPlacement="end"
      />
    </RadioGroup>
  );
};

export default RadioYearHandlingFragment;
